document.addEventListener("DOMContentLoaded", function() {
    var parentItems = document.querySelectorAll('.m-filter--widget-collections');

    parentItems.forEach(function(item) {
        var mainTitle = item.querySelector('.m-filter--widget-title');
        var submenu = item.querySelector('.submenu');

        // Esconder todos os submenus inicialmente
        var submenus = item.querySelectorAll('.submenu');
        submenus.forEach(function(submenu) {
            submenu.classList.remove('show');
        });

        // Esconder todos os sub-submenus inicialmente
        var subSubmenus = item.querySelectorAll('.sub-submenu');
        subSubmenus.forEach(function(subSubmenu) {
            subSubmenu.classList.remove('show');
        });

        // Mostrar apenas o submenu do grupo ativo inicialmente
        var activeLink = item.querySelector('.m-link-lists--item.active');
        if (activeLink) {
            var activeSubmenu = activeLink.querySelector('.submenu');
            if (activeSubmenu) {
                activeSubmenu.classList.add('show');
            }
        } else {
            var activeLinks = item.querySelectorAll('.submenu-item.active, .sub-submenu-item.active');
            activeLinks.forEach(function(activeLink) {
                var currentElement = activeLink;
                while (currentElement) {
                    var parentSubmenu = currentElement.closest('.submenu');
                    if (parentSubmenu) {
                        parentSubmenu.classList.add('show');
                    }
                    currentElement = parentSubmenu ? parentSubmenu.parentElement.closest('.submenu') : null;
                }
            });
        }

        // Mostrar o terceiro nível ao passar o mouse sobre o segundo nível
        var subLinks = item.querySelectorAll('.submenu a');
        subLinks.forEach(function(subLink) {
            var showSubSubMenuTimeout;
            var hideSubSubMenuTimeout;

            subLink.addEventListener('mouseenter', function(event) {
                clearTimeout(hideSubSubMenuTimeout);
                var subSubMenu = subLink.nextElementSibling;
                if (subSubMenu) {
                    showSubSubMenuTimeout = setTimeout(function() {
                        subSubMenu.classList.add('show');
                    }, 100); // Adiciona um pequeno atraso ao mostrar
                }
                subLink.classList.add('hovered'); // Adiciona a classe 'hovered' ao link
                subLink.style.textDecoration = 'underline'; // Adiciona sublinhado ao link
            });

            subLink.addEventListener('mouseleave', function(event) {
                clearTimeout(showSubSubMenuTimeout);
                var subSubMenu = subLink.nextElementSibling;
                if (subSubMenu) {
                    hideSubSubMenuTimeout = setTimeout(function() {
                        subSubMenu.classList.remove('show');
                    }, 200); // Adiciona um pequeno atraso ao esconder
                }
                subLink.classList.remove('hovered'); // Remove a classe 'hovered' do link
                subLink.style.textDecoration = 'none'; // Remove sublinhado do link
            });

            // Manter o sub-submenu aberto ao passar o mouse sobre ele
            var subSubMenu = subLink.nextElementSibling;
            if (subSubMenu) {
                subSubMenu.addEventListener('mouseenter', function(event) {
                    clearTimeout(hideSubSubMenuTimeout);
                });

                subSubMenu.addEventListener('mouseleave', function(event) {
                    hideSubSubMenuTimeout = setTimeout(function() {
                        subSubMenu.classList.remove('show');
                    }, 250); // Adiciona um pequeno atraso ao esconder
                });
            }
        });
    });
});